import { gql } from '@apollo/client';
import { ClaimPhotosType } from './GetClaimPhotosList';

export type PagedClaimPhotosType = {
  items: ClaimPhotosType[],
  currentPage: number,
  pageSize: number,
  totalItems: number,
};

const GET_CLAIM_PHOTOS_LIST_PAGED = gql`
query claimPhotosPaged ($regionId: Int!, $claimIndx: Int!, $currentPage: Int, $itemsPerPage: Int) {
  claimPhotosPaged(regionId: $regionId, claimIndx: $claimIndx, currentPage: $currentPage, itemsPerPage: $itemsPerPage)
  {
    items {
      filePath
      thumbnailFileName
      areaOfLoss
      phase
      description
      fileExtension
      uploadedDate
      fileMetaData
      fileSize
      fileName
      sentToXactEm
      sentToXactRe
      isCustomerVisible
      fileTypeCd
      ctfileId
      roomId
      includedInIsi
      xactimate
      isSymbilityDoc
    }
    currentPage
    pageSize
    totalItems
  }
}`;

export default GET_CLAIM_PHOTOS_LIST_PAGED;